import { listToTree, type, deepTraverse } from '../utils/assist'
import Vue from 'vue'
import RESOURCE_TYPE from './resource-type'

// 权限控制对象
function Access(options) {
	this.init(options)
}

Object.assign(Access.prototype, {
	init(options = {}) {
		// props
		this.options = Object.assign({}, Access.options, options)

		var {
			id,
			pId,
			moduleAlias, // 模块别名
			auth = []
		} = this.options

		// 最小响应式数据
		this.state = Vue.observable({ auth })
		this.userAuth = this.state.auth
		this.moduleAlias = moduleAlias

		// 树结构
		listToTree(this.userAuth, {
			id,
			pId,
			copy: false
		})

		this.authMap = {}
		this.userAuth.forEach(v => this.authMap[v.uri] = v)
	},

	aliasToUri(alias) {
		return this.moduleAlias[alias]
	},

	getAuth(alias) {
		var auth, uri

		// 取全部
		if (!alias) {
			return this.userAuth
		}

		// uri查询
		auth = this.authMap[alias]
		if (auth) {
			return auth
		}

		// 别名查询
		uri = this.aliasToUri(alias)
		auth = this.authMap[uri]

		return auth
	},

	setAuth(auth) {
		this.init({
			auth
		})
	},

	// 获取限定范围下的所有功能点
	getScopedActions(scope) {
		var actions = []

		// scope是功能点
		if (scope.type == RESOURCE_TYPE.action) {
			return [scope]
		}

		deepTraverse(scope, (auth, parent) => {
			if(auth.type == RESOURCE_TYPE.action){
				actions.push(auth)
			}
		})

		return actions
	},

	can(verb, alias) {
		var auth = this.getAuth(alias),
			actions

		if (auth) {
			// 全局查找
			if (type(auth) == "array") {
				actions = auth
			}

			// 限定scope下查找
			if (auth.children) {
				actions = this.getScopedActions(auth)
			}
		}

		// 功能点存在
		return actions ? actions.some(v => new RegExp(verb + "$").test(v.uri)) : false
	},

	have(uri, scope) {
		if (scope) {
			var target,
				result = false

			scope = this.getAuth(scope)
			target = this.getAuth(uri)

			// 递归搜索
			if(scope && target){
				deepTraverse(scope, auth => {
					if(auth.uri == target.uri){
						result = true
						
						// 停止搜索
						return false
					}
				})
			}	

			return result
		} else {
			return !!this.getAuth(uri)
		}
	}
})

// default options
Access.options = {
	id: "id",
	pId: "pid",
	moduleAlias: {}, // 模块别名
}

export default Access